/**
 * Drop grid filters with empty values so they are not sent to the API.
 * @param {import('../models/DataGridFilterParameter').default[] | import('../../utilities/list/FilterParameter').default[]} filters
 */
export const stripEmptyGridFilters = filters =>
  (Array.isArray(filters) ? filters : []).filter(
    filter => filter
      && filter.value !== null
      && filter.value !== undefined
      && filter.value !== ''
  )
